// routes
import { PATH_DASHBOARD } from '../../../routes/paths';

// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: icon('ic_user'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  banking: icon('ic_banking'),
  blank: icon('ic_blank'),
  blog: icon('ic_blog'),
  booking: icon('ic_booking'),
  calender: icon('ic_calendar'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  file: icon('ic_file'),
  folder: icon('ic_folder'),
  invoice: icon('ic_invoice'),
  kanban: icon('ic_kanban'),
  label: icon('ic_label'),
  locks: icon('ic_lock'),
  mail: icon('ic_mail'),
  menu_item: icon('ic_menu_item'),
  password: icon('ic_password'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'کاربر',
    items: [
      { title: 'تعريف كاربر', path: PATH_DASHBOARD.one, icon: ICONS.dashboard },
      { title: 'سطح دسترسی', path: PATH_DASHBOARD.two, icon: ICONS.ecommerce },
      { title: 'تعریف تامین کننده', path: PATH_DASHBOARD.three, icon: ICONS.analytics },
      { title: 'اعتبار تامین کننده', path: PATH_DASHBOARD.test, icon: ICONS.blank },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      {
        title: 'user',
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user,
        children: [
          { title: 'Four', path: PATH_DASHBOARD.user.four },
          { title: 'Five', path: PATH_DASHBOARD.user.five },
          { title: 'Six', path: PATH_DASHBOARD.user.six },
        ],
      },
    ],
  },
];

export default navConfig;
